import React from 'react'
import AddAgentForm from '../components/AgentForm.jsx/AddAgentForm';
const AddAgents = () => {
  return (
    <div className='w-full'>
      <div>
        <AddAgentForm />
      </div>
    </div>
  )
}

export default AddAgents